<div class="summary" [ngClass]="{'summary-opened': opened}">
      <!--  new class ".marked" to highlight a SUMMARY  -->
    <div class="summary-box-content" [ngClass]="{'unwrap': (diffLabels.length==0 && ((feedbacksList != null && feedbacksList.length > 0) || (bubblesList != null && bubblesList.length > 0)))}">
      <div class="summary-group-main">
        <span class="summary-group" [ngClass]="{'not-clickable': listItemModeOnly}" title="Open artwork" (click)="toogleFiles($event)">
          <span class="version">{{version.version}}</span>
          <span class="id">(#{{version.id}})</span>
          <span [hidden]="listItemModeOnly" class="arrow-marker"  [ngClass]="{'arrow-marker-open': opened,'arrow-marker-closed': !opened}"></span>
        </span>
        <span class="status" title="Artwork status: {{version.status.name}}" [style.background-color]="version.status.color">{{version.status.name}}</span>
          <span class="uploaded" title="Artwork uploaded from this project" [hidden]="!uploaded"></span>
        <div class="version-bubbles" *ngIf="feedbacksList != null">
          <div class="version-feedback-bubble" *ngFor="let feedback of feedbacksList">
            <core-helpers-icons-colored-bubble-circle-letter
                [title]="getBubbleTitle(feedback)"
                [color]="getBubbleColor(feedback)"
            ></core-helpers-icons-colored-bubble-circle-letter>
          </div>
        </div>
        <div class="version-bubbles" *ngIf="bubblesList != null">
          <div class="version-feedback-bubble" *ngFor="let share of bubblesList">
            <core-helpers-icons-colored-bubble-circle-letter
                [title]="getBubbleTitle(share)"
                [color]="getShareBubbleColor(share)"
            ></core-helpers-icons-colored-bubble-circle-letter>
          </div>
          
        </div>
        <div class="version-bubbles-dimmed dimmed" *ngIf="feedbacksList == null && bubblesList == null">
          <div class="dimmed_flex">
            <span></span><span></span><span></span>
            </div>
        </div>
      </div>
      <div class="diff-labels" >
          <span class="plus" [hidden]="diffLabels.length==0 || diffLabels.length==version.labels.length">+ </span>
          <core-labels-text [labels]="diffLabels" *ngIf="!areLabelsObserved"></core-labels-text>
          <!-- list only displayed when action for labels click to select is set -->
          <core-labels-list [labels]="diffLabels" *ngIf="areLabelsObserved" (choose)="onLabelSelect($event)"></core-labels-list>
      </div>

      <div class="summary-author-date">
        <div class="summary-author-date-main">
          <span class="summary-author">{{version.user_owner.name}}</span>
          <span class="summary-date">{{version.date_created | date: 'dd MMM yyyy'}}</span>
        </div>
      </div>
      <core-helpers-navigation-three-dots-menu
          [menu]="menu"
          (action)="onMenuSelect($event)"
      ></core-helpers-navigation-three-dots-menu>
    </div>

    <div class="files" [hidden]="!opened">
        <!-- loading -->
        <div class="dimmed" [hidden]="status != STATUS_LOADING">
            <div class="dimmed_subtitle"></div>
          </div>
        <!--files-->
        <core-files-list-default *ngIf="status == STATUS_DONE"
            [files]="files"
            (actionClick)="actionFileClick.emit($event)"
            (iconDownloadClick)="onActionDownloadClick($event)"
        ></core-files-list-default>
        <div class="message-not-content" *ngIf="status == STATUS_DONE && files.length == 0"><p>This artwork has no files.</p></div>
    </div>
</div>
